/** The app's OIDC session (realm `customers`, client `brevalt-app`, min ACR `mfa`). */
import { AuthSession } from "@brevalt/app-core";
import { config } from "./config";

export const session = new AuthSession({
  authority: config.oidcAuthority,
  clientId: config.oidcClientId,
  origin: window.location.origin,
  loginAcr: "mfa",
  // A step-up token counts too (it is at least mfa).
  acceptedAcr: ["mfa", "stepup"],
});
